export default __webpack_public_path__ + "static/media/icon-profile-big.4f54c510.svg";